import {GET_SUBMENU2, SUBMENU2_ERROR} from '../types'

const initialState = {
    subMenu2:[],
    loading:true
}

export default function(state = initialState, action){

    switch(action.type){

        case GET_SUBMENU2:
        return {
            ...state,
            subMenu2:action.payload,
            loading:false

        }
        case SUBMENU2_ERROR:
            return{
                loading: false, 
                error: action.payload 
            }
        default: return state
    }

}